// src/components/auth/ProtectedRoute.js
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
      <p className="mt-4 text-sm text-gray-600">Checking authentication...</p>
    </div>
  </div>
);

const ProtectedRoute = () => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking session
  if (loading) {
    return <LoadingSpinner />;
  }

  // If not authenticated, redirect to login with return URL
  if (!isAuthenticated) {
    // Get the full path including any query params
    const returnPath = location.pathname + location.search;
    
    // Save to sessionStorage as backup
    sessionStorage.setItem('returnUrl', returnPath);
    console.log('ProtectedRoute: Saving returnUrl =', returnPath);
    
    // Pass return URL as query parameter (most reliable method)
    const loginUrl = `/login?returnUrl=${encodeURIComponent(returnPath)}`;
    
    return <Navigate to={loginUrl} replace />;
  }

  // If authenticated, render the child routes
  return <Outlet />;
};

export default ProtectedRoute;
